import { render } from "./PrintSettingsTab.vue?vue&type=template&id=107fcc66"
import script from "./PrintSettingsTab.vue?vue&type=script&lang=js"
export * from "./PrintSettingsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__